//@flow

export const isBuild      = () => process.env.NODE_ENV === 'production' // set by react-app if running build-process
export const isProduction = () => process.env.REACT_APP_ENV === 'production' // set by package json when running 'startprod' or 'buildprod'

export const getHost = () => {
  return isBuild()
    ? isProduction() ? 'https://www.cryptorunup.com' : 'https://www.cryptorunup.com'
    : 'https://cryptorunup.com'
    // : 'http://localhost:5000' //
  }

export const bypassCache = () => {
  return (isBuild() && !window.loggedIn) ? false : true
}



// WEBPACK FOOTER //
// ./src/configs/index.js